import { Helmet } from "react-helmet-async";
import { Fragment } from "react/jsx-runtime";
import { decodeText } from "../../../utils/richText";

const HtmlHeader = ({ title, meta, geo }) => {
    return (
        <Helmet>
            {title && <title>{decodeText(title)}</title>}

            {meta && (
                <Fragment>
                    {meta.description && <meta name="description" content={decodeText(meta.description)} />}
                    {meta.keywords && <meta name="keywords" content={decodeText(meta.keywords)} />}
                </Fragment>
            )}

            {geo && (
                <Fragment>
                    {geo.speakableSummary && <meta name="ai-voice-summary" content={geo.speakableSummary}></meta>}
                    {geo.jsonLD && <script type="application/ld+json">{geo.jsonLD}</script>}
                </Fragment>
            )}
        </Helmet>
    );
};

export default HtmlHeader;
